// extracted by mini-css-extract-plugin
export default {"btn":"Dashbord_btn__rAxHP","gradientt":"Dashbord_gradientt__EZBm2","line":"Dashbord_line__YtIqe","border":"Dashbord_border__m5Zsx"};